module.exports = __webpack_public_path__ + "img/messages.377b4489.svg";